const MEDIA_LABELS = {
  image: "Imagem",
  audio: "Áudio",
  video: "Vídeo",
  document: "Documento",
};

export function normalizeMediaType(value, fallbackText = "") {
  const raw = String(value || "")
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");
  const text = String(fallbackText || "")
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");
  const source = `${raw} ${text}`;
  if (source.includes("image") || source.includes("imagem")) return "image";
  if (source.includes("audio") || source.includes("audio")) return "audio";
  if (source.includes("video") || source.includes("video")) return "video";
  if (source.includes("document") || source.includes("documento") || source.includes("arquivo")) return "document";
  return raw || null;
}

export function cleanTechnicalMediaText(text, mediaType) {
  if (!text) return "";
  const value = String(text).trim();
  const normalized = value
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");

  const match = normalized.match(/^\[(image|imagem|audio|video|document|documento|arquivo)(?::[^\]]*)?\]$/);
  if (match) {
    const type = normalizeMediaType(mediaType || match[1]);
    return MEDIA_LABELS[type] || "";
  }

  return value
    .replace(/\[(image|imagem)\]/gi, "Imagem")
    .replace(/\[(audio|áudio)\]/gi, "Áudio")
    .replace(/\[(video|vídeo)\]/gi, "Vídeo")
    .replace(/\[(document|documento|arquivo)(?::[^\]]*)?\]/gi, "Documento")
    .trim();
}

export function isOnlyTechnicalMediaText(text) {
  if (!text) return false;
  const normalized = String(text)
    .trim()
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");
  return /^\[(image|imagem|audio|video|document|documento|arquivo)(?::[^\]]*)?\]$/.test(normalized);
}

export function mediaPreviewLabel(mediaType, fallbackText = "") {
  const type = normalizeMediaType(mediaType, fallbackText);
  return MEDIA_LABELS[type] || cleanTechnicalMediaText(fallbackText, type);
}
